/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ state: NonNullable<unknown> }} Receipt_Timeline_StartedInputs */



/**
* | output |
* | --- |
* | "Started: {state}" |
*
* @param {Receipt_Timeline_StartedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_timeline_started = /** @type {((inputs: Receipt_Timeline_StartedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Timeline_StartedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Start: ${i?.state}`)
	return /** @type {LocalizedString} */ (`Started: ${i?.state}`)
});